import { render } from "./PageNumList.vue?vue&type=template&id=0190a680&scoped=true"
import script from "./PageNumList.vue?vue&type=script&lang=js"
export * from "./PageNumList.vue?vue&type=script&lang=js"

import "./PageNumList.vue?vue&type=style&index=0&id=0190a680&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0190a680"]])

export default __exports__